import "@cakewalk/ui/styles/index.css";
import { configureAmplify } from "@cakewalk/frontend-auth";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadCompanyCensusEnv } from "./env";
import "./index.css";
import "./styles/cakewalk-v2.css";

const env = loadCompanyCensusEnv();

// Cognito is only needed for the "log in" path. Guests can complete the whole
// flow without it, so — unlike registration — we DON'T hard-fail when the
// Cognito vars are absent; we just skip Amplify config (login will surface a
// friendly error if attempted) and let guest mode work.
if (env.VITE_COGNITO_USER_POOL_ID && env.VITE_COGNITO_CLIENT_ID) {
  configureAmplify({
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    userPoolClientId: env.VITE_COGNITO_CLIENT_ID,
    apiEndpoint: env.VITE_API_BASE_URL,
    awsRegion: env.VITE_COGNITO_REGION,
  });
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
